// Monogram avatar palette. The player has no photo upload (yet) — instead they pick
// a colour tone for their initials, stored as `avatarTone` on the user doc. Index 0
// is the default "ink" look used everywhere else in the app.
export interface AvatarTone {
  from: string;
  to: string;
}

export const AVATAR_TONES: AvatarTone[] = [
  { from: '#2A2A33', to: '#0E0E12' }, // Ink (default)
  { from: '#24C56A', to: '#08A079' }, // Green
  { from: '#5AA6E6', to: '#1E4E7A' }, // Blue
  { from: '#C9B8F0', to: '#7E5BD6' }, // Violet
  { from: '#FCDE7C', to: '#E3A82B' }, // Gold
  { from: '#E0726E', to: '#D2544F' }, // Coral
  { from: '#5BD6C2', to: '#0E9488' }, // Teal
  { from: '#F2A65A', to: '#D2761F' } // Amber
];

export function toneFor(index: number | undefined): AvatarTone {
  return AVATAR_TONES[(index ?? 0) % AVATAR_TONES.length];
}
